<script lang="ts">
	interface Props {
		title: string
		videoURL: string
	}

	let { title, videoURL }: Props = $props()

	function toEmbedURL(url: string): string {
		const embedUrl = url.replace("watch?v=", "embed/")
		console.log(`${url} -> ${embedUrl}`)
		return embedUrl
	}
</script>

<div class="video-container" aria-label={title}>
	<iframe
		src={toEmbedURL(videoURL)}
		{title}
		allowfullscreen
		frameborder="0"
		allow="autoplay; fullscreen"
	></iframe>
</div>

<style>
	.video-container {
		position: relative;
		width: 100%;
		padding-bottom: 56.25%; /* 16:9 aspect ratio */
		height: 0;
		overflow: hidden;
	}

	.video-container iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border: none;
	}
</style>
